import { HttpInterceptorFn } from '@angular/common/http';
import { signal } from '@angular/core';
import { finalize } from 'rxjs';

export const isGlobalLoading = signal<boolean>(false);
let activeRequestsCount = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (activeRequestsCount === 0) {
    isGlobalLoading.set(true);
  }
  activeRequestsCount++;

  return next(req).pipe(
    finalize(() => {
      activeRequestsCount--;
      if (activeRequestsCount <= 0) {
        activeRequestsCount = 0;
        isGlobalLoading.set(false);
      }
    }),
  );
};
